import React from 'react';

interface CardProps {
  children: React.ReactNode;
  hoverable?: boolean;   // 是否启用悬浮效果
  className?: string;
  onClick?: () => void;
}

/**
 * Card 组件 - 可复用的卡片容器
 * 
 * @param children - 卡片内容
 * @param hoverable - 是否启用悬浮效果（阴影加深和轻微上移）
 * @param className - 额外的 CSS 类名
 * @param onClick - 点击事件处理函数
 */
export function Card({ 
  children, 
  hoverable = false, 
  className = '', 
  onClick 
}: CardProps) {
  // 基础样式
  const baseStyles = 'bg-white rounded-xl shadow-sm border border-gray-100 p-6';
  
  // 悬浮效果样式：阴影加深 + 轻微上移
  const hoverStyles = hoverable 
    ? 'transition-all duration-300 hover:shadow-lg hover:-translate-y-2 hover:border-primary-200 cursor-pointer' 
    : '';
  
  // 组合所有样式
  const combinedStyles = `${baseStyles} ${hoverStyles} ${className}`.trim();

  return (
    <div 
      className={combinedStyles}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => {
        // 支持键盘访问：Enter 或 Space 键触发点击
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      } : undefined}
    >
      {children}
    </div>
  );
}
